const formaPagamento = [
  { text: 'Boleto', value: 0 },
  { text: 'Cartão de Crédito', value: 1 },
  { text: 'Cartão de Débito', value: 2 },
  { text: 'Dinheiro', value: 3 },
  { text: 'Pix', value: 4 },
];

export default formaPagamento;
